/**
 * The identity provider sent the browser back without a usable code, or refused the sign-in. It carries
 * the provider's own `error` and `error_description` so the failed screen can say why.
 */
export class AuthorizationRefusedError extends Error {
    public constructor(
        public readonly providerError: string | undefined,
        public readonly providerDescription: string | undefined,
    ) {
        super(providerDescription ?? providerError ?? 'The authorization response was not valid')
        this.name = 'AuthorizationRefusedError'
        Object.setPrototypeOf(this, new.target.prototype)
    }
}
